module.exports = __webpack_public_path__ + "static/media/view.dc0f45db.svg";